export default __webpack_public_path__ + "static/reviews-video-nuno-0b0dc61d3e5495b98a66a4c27ebcfa6f.png";